// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverRelayTestRequest {
	relay: number;

	seconds: number;

	$type?: string | undefined;
}
export class DriverRelayTestRequest {
	constructor(data?: IDriverRelayTestRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	relay: number = 0;

	seconds: number = 0;

	static $type: string = "CoreApi.Models.DriverRelayTestRequest, ";
	$type?: string | undefined = DriverRelayTestRequest.$type;
}

